import React, { useContext, useEffect, useReducer, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { default as ReactSelect } from "react-select";
import { toast } from "react-toastify";
import { Store } from "../Store";
import { default as config } from "../config.json";
import useSampleProductsAndCategories from "../hooks/useSampleProductsAndCategories";
import { capitalize, getError } from "../utils";
import Gorsel from "./Gorsel";
import LoadingBox from "./LoadingBox";
import Option from "./Option";
import useAxios from "../hooks/useAxios";

const reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_REQUEST":
      return { ...state, loadingUpdate: true };
    case "UPDATE_SUCCESS":
      return { ...state, loadingUpdate: false };
    case "UPDATE_FAIL":
      return { ...state, loadingUpdate: false };
    default:
      return state;
  }
};
export default function CategorySampleEditor(props) {
  const axios = useAxios();
  const { category, setShowCategoryEditor } = props;

  const { state } = useContext(Store);
  const { userInfo, allCategories, products } = state;
  const [{ loadingUpdate }, dispatch] = useReducer(reducer, {
    loadingUpdate: false,
  });

  const [name, setName] = useState("");
  const [basic, setBasic] = useState(true);
  const [image, setImage] = useState("");
  const [isRoot, setIsRoot] = useState(true);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);

  const [
    loadingProducts,
    errorLoadingProducts,
    setLoadProducts,
    setLoadCategories,
  ] = useSampleProductsAndCategories();

  useEffect(() => {
    if (category._id) {
      setName(category.name);
      setBasic(category.basic);
      setImage(category.image);
      setIsRoot(category.isRoot);
      setSelectedCategories(category.categories.map((c) => c._id));
      setSelectedProducts(category.products.map((p) => p._id));
    }
  }, [category]);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      dispatch({ type: "UPDATE_REQUEST" });
      !category._id
        ? await axios.post("/api/categorysamples", {
            name,
            image: image || config.default_image,
            isRoot,
            basic,
            categories: selectedCategories,
            products: selectedProducts,
          })
        : await axios.put(`/api/categorysamples/${category._id}`, {
            _id: category._id,
            name,
            image,
            isRoot,
            basic,
            categories: selectedCategories,
            products: selectedProducts,
          });

      setShowCategoryEditor(false);
      dispatch({
        type: "UPDATE_SUCCESS",
      });
      setLoadProducts(true);
      setLoadCategories(true);
      toast.success("Kategori basarili bir sekilde kaydedildi");
    } catch (err) {
      toast.error(getError(err));
      dispatch({ type: "UPDATE_FAIL" });
    }
  };

  return (
    <div>
      <Form onSubmit={submitHandler}>
        <Form.Group className="mb-3">
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio1"
              value="temel"
              onChange={(e) => setBasic(true)}
              checked={basic}
            />
            <label className="form-check-label" for="inlineRadio1">
              Temel Seviye
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio2"
              value="ileri"
              onChange={(e) => setBasic(false)}
              checked={!basic}
            />
            <label className="form-check-label" for="inlineRadio2">
              İleri Seviye
            </label>
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Adı</Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(capitalize(e.target.value))}
            required
          />
        </Form.Group>

        <Gorsel
          image={image}
          setImage={setImage}
          entityId={category._id}
          entityName={"categorysample"}
        ></Gorsel>

        <Form.Group className="mb-3">
          <Form.Check
            type="checkbox"
            label="Ana kategori mi?"
            value={isRoot}
            checked={isRoot}
            onChange={(e) => setIsRoot(e.target.checked)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Alt Kategoriler</Form.Label>
          <div className="mb-3">
            <ReactSelect
              options={allCategories
                .filter((c) => c._id !== category._id && !category.isRoot)
                .map((c) => {
                  return { value: c._id, label: c.name };
                })}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{
                Option,
              }}
              onChange={(selected) => {
                setSelectedCategories(selected.map((entry) => entry.value));
              }}
              allowSelectAll={true}
              value={allCategories
                .filter((c) => selectedCategories.includes(c._id))
                .map((c) => {
                  return { value: c._id, label: c.name };
                })}
            />
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Ürünler</Form.Label>
          <div className="mb-3">
            <ReactSelect
              options={products.map((p) => {
                return { value: p._id, label: p.name };
              })}
              isMulti
              closeMenuOnSelect={false}
              hideSelectedOptions={false}
              components={{
                Option,
              }}
              onChange={(selected) => {
                setSelectedProducts(selected.map((entry) => entry.value));
              }}
              allowSelectAll={true}
              value={products
                .filter((p) => selectedProducts.includes(p._id))
                .map((p) => {
                  return { value: p._id, label: p.name };
                })}
            />
          </div>
        </Form.Group>

        <div className="mb-3">
          <Button
            disabled={loadingUpdate}
            type="submit"
            variant="light"
            className="text-primary border-primary"
          >
            {!category._id ? "Kaydet" : "Güncelle"}
          </Button>
          {loadingUpdate && <LoadingBox></LoadingBox>}
        </div>
      </Form>
    </div>
  );
}
